// extracted by mini-css-extract-plugin
export var clearButton = "FilterBar-module--clearButton--jJ1bY";
export var large = "FilterBar-module--large--OV-ub";
export var root = "FilterBar-module--root--CkxfE";